import { TActions } from '../../../../AppModulesWrapper';
import { IUIState } from '../../../types/reducers';
import { defaultState } from './defaultState';
import {
  LOAD_PUBLISH_TERMS_FAIL,
  LOAD_PUBLISH_TERMS_START,
  LOAD_PUBLISH_TERMS_SUCCESS,
} from '../../../actions/publishTerms';
import { EPublishTermsStatus } from '../../../types/reducers/publishTerms';

export const uiReducer = (state: IUIState = defaultState, action: TActions): IUIState => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_START: {
      return {
        publishTerms: {
          status: action.payload.isReloading ? EPublishTermsStatus.success : EPublishTermsStatus.pending,
        },
      };
    }
    case LOAD_PUBLISH_TERMS_FAIL: {
      return {
        publishTerms: {
          status: EPublishTermsStatus.fail,
        },
      };
    }
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return {
        publishTerms: {
          status: EPublishTermsStatus.success,
        },
      };
    }
    default:
      return state;
  }
};
